var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid kanban-page"},[_c('div',{staticClass:"row d-flex h-100"},[_c('div',{staticClass:"col-lg-12 d-flex flex-column"},[_c('card',{staticClass:"card-kanban flex-grow-1 d-flex flex-column"},[_c('kanban-view')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }